module.exports = __webpack_public_path__ + "img/dance-school-icon7.b200d496.png";